var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.75C3.58579 11.75 3.25 12.0858 3.25 12.5C3.25 12.9142 3.58579 13.25 4 13.25H13.25V18.5C13.25 18.8034 13.4327 19.0768 13.713 19.1929C13.9932 19.309 14.3158 19.2449 14.5303 19.0304L20.5303 13.0304C20.671 12.8897 20.75 12.6989 20.75 12.5C20.75 12.3011 20.671 12.1103 20.5303 11.9697L14.5303 5.96969C14.3158 5.75519 13.9932 5.69103 13.713 5.80711C13.4327 5.9232 13.25 6.19668 13.25 6.50002V11.75H4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.10fa689e0dfd0a37ab27657d2c5942f7.svg";
export { ForwardRef as ReactComponent };